<template>
  <img v-if="module" :src="module.icon" :alt="module.name">
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('module', [
        'definitionModulesInstalled'
      ]),
      module () {
        return this.definitionModulesInstalled.find(modules => modules.identifier === this.identifier)
      }
    },
    props: {
      identifier: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  img
    max-height: 20px
</style>




// WEBPACK FOOTER //
// ModuleIcon.vue?4c1c59fe